// src/common/utils/roleUtils.ts

export const ADMIN_ROLES = ["superadmin", "admin"];

export const ESTIMATION_ROLES = [
  "superadmin",
  "admin",
  "estimator"
];

export const RENTAL_EQUIPMENT_ROLES = [
  "superadmin",
  "admin",
  "projectmanager",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager"
];

export const DENY_CHART_AND_LISTING = [
  "fieldmanager",
  "shopmanager",
  "transport",
  "receivingmanager",
  "serviceperson",
  "user"
];

export const DENY_SHOP_PERSONAL = [
  "fieldmanager",
  "transport",
  "receivingmanager",
  "serviceperson",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager",
  "user"
];

export const DENY_RECEIVING = [
  "fieldmanager",
  "transport",
  "shopmanager",
  "serviceperson",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager",
  "user"
];

export const DENY_TRANSPORT = [
  "receivingmanager",
  "shopmanager",
  "serviceperson",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager"
];

export const DENY_MAINTENANCE = [
  "fieldmanager",
  "transport",
  "shopmanager",
  "receivingmanager",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager",
  "user"
];

export const DENY_INVENTORY = [
  "fieldmanager",
  "transport",
  "serviceperson",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager",
  "user"
];

export const DENY_FIELD_CREW = [
  "shopmanager",
  "transport",
  "receivingmanager",
  "serviceperson",
  "fieldforeman",
  "fieldsafety",
  "purchasingmanager",
  "resourcemanager",
  "user"
];
